<template>
<div>
  <table class="table table-hover">
    <thead>
    <tr>
      <th>Status</th>
      <th>Name</th>
      <th>Completion</th>
      <th>Url</th>
      <th>Tiers</th>
      <th>Added</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="pyramid in pyramids" :key="pyramid.id">
      <td>
        <span class="label label-primary">{{ pyramid.status }}</span>
      <td>
        <router-link :to="{path:'/apps/link-pyramid/' + pyramid.id}">{{ pyramid.name }}</router-link><br>
        <small>{{ pyramid.description }}</small>
      </td>
      <td class="project-completion">
        <template v-if="pyramid.status === 'COMPLETED' || pyramid.status === 'RUNNING'">
          <small>Completion: {{ Math.round(pyramid.deployed.deployed / pyramid.deployed.expected * 100) }}% ({{ pyramid.deployed.deployed }}/{{ pyramid.deployed.expected }})</small>
          <div class="progress progress-mini">
            <div :style="'width: '+ Math.round(pyramid.deployed.deployed / pyramid.deployed.expected * 100) + '%;'" class="progress-bar"></div>
          </div>
        </template>
      </td>
      <td>
        <span :title="pyramid.url.join(',')">{{ pyramid.url.length }} urls</span>
      </td>
      <td>{{ pyramid.tiers.length }}</td>
      <td>{{ $moment(pyramid.added).format('D.M.Y HH:ss') }}</td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'List',
  data () {
    return {
      pyramids: []
    }
  },
  mounted () {
    this.getPyramids()
  },
  methods: {
    getPyramids () {
      axios.get('/link-pyramids')
        .then(result => {
          this.pyramids = result.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Apps/link-pyramid/List.vue